import React from 'react'
import { Link } from 'react-router-dom'

const ButtonComp = ({btnText,link,img,className}) => {
  if (typeof link === 'function') {
    return (
      <button onClick={link} className={`primary-btn text-center ${className}`} style={{ border: 'none' }}>
        {btnText} {" "}
        <img src={`${img ? img : "/images/web-new-images/right-arrow.svg"}`} alt="LA"/>
      </button>
    )
  }
  const isExternal = link && (link.startsWith('http://') || link.startsWith('https://'));
  if (isExternal) {
    return (
      <a href={link} className={`primary-btn text-center ${className}`}>
        {btnText} {" "}
        <img src={`${img ? img : "/images/web-new-images/right-arrow.svg"}`} alt="LA"/>
      </a>
    )
  }
  return (
        <Link to={link || '/auth/register'} className={`primary-btn text-center ${className}`}>
        {btnText} {" "}
        <img src={`${img ? img : "/images/web-new-images/right-arrow.svg"}`} alt="LA"/>
        </Link>
  )
}

export default ButtonComp
